module.exports = __webpack_public_path__ + "img/apex.a7683bac.jpg";